import { createRef, useEffect } from 'react';

export function useFocusOnMount(inputs) {
    const ref = createRef();
    useEffect(() => {
        setTimeout(() => ref.current && ref.current.focus(), 0);
    }, inputs);
    return ref;
}
